// extracted by mini-css-extract-plugin
export default {"highlights":"highlights--mp-WIWXb"};